import GenericFilterRow from '../search/GenericFilterRow';

export interface ResultFilters {
  yearFrom?: number;
  yearTo?: number;
  faculties: string[];
  types: string[];
}

interface ResultsFilterRowProps {
  value: ResultFilters;
  onChange: (next: ResultFilters) => void;
  inert?: boolean;
}

export default function ResultsFilterRow({ value, onChange, inert = false }: ResultsFilterRowProps) {
  return (
    <GenericFilterRow<ResultFilters>
      namespace="projects"
      value={value}
      onChange={onChange}
      inert={inert}
    />
  );
}
